import User from "../models/User";
import http from "./http";

export const Login = async (email: string, password: string) => {
	const { data } = await http.post(`/auth/login`, {
		email: email,
		password: password,
	});
	if (!data) {
		throw "error login";
	}
	const { data: me } = await http.get(`/auth/me`, {
		headers: {
			Authorization: `Bearer ${data.accessToken}`,
		},
	});

	// let datalogin = new User().parse(me);
	let user = new User().parse(me);
	user.expireTime = new Date(data.expiredIn);
	user.token = data.accessToken;
	user.refreshToken = data.refreshToken;
	return user;
};

export const Register = async (
	name: string,
	email: string,
	password: string,
	confirmPassword: string,
	communicationId: string,
	phone: string
) => {
	const { data } = await http.post(`/auth/signup`, {
		email: email,
		password: password,
		confirmPassword: confirmPassword,
		fullName: name,
		communicationId: communicationId,
		phonePrefix: "+84",
		phone: phone,
	});
	return data;
};

export const ForgotPass = async (email: string) => {
	const { data } = await http.post(`/auth/init-forget-password`, {
		email: email,
	});
	return data;
};

export const updateForgetPassword = async (resetkey: string, pass: string, repass: string) => {
	const { data } = await http.post(`/auth/update-forget-password`, {
		resetKey: resetkey,
		password: pass,
		confirmPassword: repass,
	});
	return data;
};
